<template>
  <v-layout justify-center>
    <v-dialog v-model="visible" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"> {{ title }}</v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="visible = false">{{
            noButton
          }}</v-btn>
          <v-btn color="green darken-1" text @click="confirm">{{
            yesButton
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  name: "confirm-dialog",
  props: ["title", "message", "yesButton", "noButton"],
  data() {
    return {
      visible: false
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    confirm() {
      this.visible = false;
      this.$emit("confirm");
    }
  }
};
</script>
